import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {EntityKeyService} from '@pma-entity/services/entity-key.service';
import {EntityDataLayoutService} from "@layout/layouts/entity-data/entity-data-layout.service";
import {ListPageComponentBase} from "@mojo-mci/list-page-component-base";

@Component({
    selector: 'mojo-client-parent-list-page',
    templateUrl: './client-parent-list-page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ClientParentListPageComponent
  extends ListPageComponentBase
  implements OnInit, OnDestroy {

  constructor(
    private readonly router: Router,
    entityKeyService: EntityKeyService,
    entityDataLayoutService: EntityDataLayoutService) {
    super(entityKeyService, entityDataLayoutService);
  }

  ngOnInit(): void {
    super.ngOnInit('Client Parents');
  }

  handleRowSelect(data) {
    this.router.navigate(['/entity-data/client-parent', data['SystemClientParentRef']]);
  }

  getRowHref = (row) => {
    const clientParentRef = row['SystemClientParentRef'];
    return `/entity-data/client-parent/${clientParentRef}`;
  }
}
